import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Query} from 'react-apollo';

import GetMe from '../graphql/queries/GetMe';
// import {AUTHENTICATION_DATA_LOCALSTORAGE_KEY} from '../constants/constants';
// import localStorage from '../utils/localStorage';

const UserContext = React.createContext();

const UserConsumer = UserContext.Consumer;

class UserProvider extends Component {
    // checkSession() {
    //     if(this.props.cookies.get(AUTHENTICATION_DATA_LOCALSTORAGE_KEY) && this.props.cookies.get(AUTHENTICATION_DATA_LOCALSTORAGE_KEY).accessPartner){
    //         if(!localStorage.getItem(AUTHENTICATION_DATA_LOCALSTORAGE_KEY) || localStorage.getItem(AUTHENTICATION_DATA_LOCALSTORAGE_KEY).accessToken !== this.props.cookies.get(AUTHENTICATION_DATA_LOCALSTORAGE_KEY).accessToken)
    //             localStorage.setItem(AUTHENTICATION_DATA_LOCALSTORAGE_KEY, JSON.stringify(this.props.cookies.get(AUTHENTICATION_DATA_LOCALSTORAGE_KEY)));
    //     }
    // }

    render() {
        //this.checkSession();

        return (
            <Query query={GetMe}>
                {({loading, error, data}) => {
                    if (loading) {
                        return null;
                    }

                    return (
                        <UserContext.Provider value={{currentUser: !loading && !error && data.me}}>
                            {this.props.children}
                        </UserContext.Provider>
                    );
                }}
            </Query>
        );
    }
}

UserProvider.propTypes = {
    cookies: PropTypes.object,
    children: PropTypes.any
};

export {UserProvider, UserConsumer};
